/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserPresenceResponseDto
 */
export interface UserPresenceResponseDto {
    /**
     * User ID
     * @type {string}
     * @memberof UserPresenceResponseDto
     */
    userId: string;
    /**
     * User status
     * @type {string}
     * @memberof UserPresenceResponseDto
     */
    status: UserPresenceResponseDtoStatusEnum;
    /**
     * Last seen timestamp
     * @type {Date}
     * @memberof UserPresenceResponseDto
     */
    lastSeen?: Date;
}


/**
 * @export
 */
export const UserPresenceResponseDtoStatusEnum = {
    Online: 'online',
    Offline: 'offline'
} as const;
export type UserPresenceResponseDtoStatusEnum = typeof UserPresenceResponseDtoStatusEnum[keyof typeof UserPresenceResponseDtoStatusEnum];


/**
 * Check if a given object implements the UserPresenceResponseDto interface.
 */
export function instanceOfUserPresenceResponseDto(value: object): value is UserPresenceResponseDto {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function UserPresenceResponseDtoFromJSON(json: any): UserPresenceResponseDto {
    return UserPresenceResponseDtoFromJSONTyped(json, false);
}

export function UserPresenceResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPresenceResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'status': json['status'],
        'lastSeen': json['lastSeen'] == null ? undefined : (new Date(json['lastSeen'])),
    };
}

export function UserPresenceResponseDtoToJSON(json: any): UserPresenceResponseDto {
    return UserPresenceResponseDtoToJSONTyped(json, false);
}

export function UserPresenceResponseDtoToJSONTyped(value?: UserPresenceResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'status': value['status'],
        'lastSeen': value['lastSeen'] == null ? undefined : ((value['lastSeen']).toISOString()),
    };
}

